__turbopack_context__.v({
  "className": "lexend_b9174c9e-module__rjrbUW__className",
});
